import React from 'react';

interface LogoutIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const LogoutIcon: React.FC<LogoutIconProps> = ({
  width = 16,
  height = 14,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M5 2C5.55312 2 6 1.55313 6 1C6 0.446875 5.55312 0 5 0H3C1.34375 0 0 1.34375 0 3V11C0 12.6562 1.34375 14 3 14H5C5.55312 14 6 13.5531 6 13C6 12.4469 5.55312 12 5 12H3C2.44688 12 2 11.5531 2 11V3C2 2.44688 2.44688 2 3 2H5ZM15.7063 7.70625C16.0969 7.31563 16.0969 6.68125 15.7063 6.29063L11.7063 2.29063C11.3156 1.9 10.6812 1.9 10.2906 2.29063C9.9 2.68125 9.9 3.31563 10.2906 3.70625L12.5844 6H6C5.44688 6 5 6.44688 5 7C5 7.55312 5.44688 8 6 8H12.5844L10.2906 10.2937C9.9 10.6844 9.9 11.3188 10.2906 11.7094C10.6812 12.1 11.3156 12.1 11.7063 11.7094L15.7063 7.70938V7.70625Z"
      fill={color}
    />
  </svg>
);

export default LogoutIcon;
